import { render, staticRenderFns } from "./MenuAccount.vue?vue&type=template&id=aabb65e4&scoped=true&"
var script = {}
import style0 from "./MenuAccount.vue?vue&type=style&index=0&id=aabb65e4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aabb65e4",
  null
  
)

export default component.exports